'use client';

import { Box, Image } from '@doist/marketist';
import { addProtocol } from 'app/services/contentful/add-protocol-to-url';
import { RenderRichText } from 'app/services/contentful/render-rich-text';
import { ContainerTwoColumns } from 'components/container-two-column/container-two-column';
import { TextLockUp } from 'components/text-lock-up/text-lock-up';
import css from './prefooter.module.css';
import type { IntegrationsHomeData } from '../../../types';
function Prefooter({
  fields: {
    prefooter
  }
}: IntegrationsHomeData) {
  const {
    header = '',
    subheader = '',
    illustration,
    description
  } = prefooter?.fields ?? {};
  const subtitle = description ? <RenderRichText>{description}</RenderRichText> : subheader;
  return <Box className={css.prefooterBackground} style={{
    '--background-color': 'var(--composition-background-yellow)'
  }} data-sentry-element="Box" data-sentry-component="Prefooter" data-sentry-source-file="prefooter.tsx">
            <ContainerTwoColumns width="base" className={css.container} breakAbove="lg" data-sentry-element="ContainerTwoColumns" data-sentry-source-file="prefooter.tsx">
                <ContainerTwoColumns.BodyContainer className={css.leftColumn} data-sentry-element="unknown" data-sentry-source-file="prefooter.tsx">
                    <Box className={css.image} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                        <Image width={372} height={237} src={addProtocol(illustration?.fields.file?.url ?? '')} alt="" data-sentry-element="Image" data-sentry-source-file="prefooter.tsx" />
                    </Box>
                </ContainerTwoColumns.BodyContainer>

                <Box className={css.rightColumn} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                    <TextLockUp withoutWrapper title={header} data-sentry-element="TextLockUp" data-sentry-source-file="prefooter.tsx">
                        {subtitle}
                    </TextLockUp>
                </Box>
            </ContainerTwoColumns>
        </Box>;
}
export { Prefooter };